import { systemApi } from '../../../redux/api/SystemApi';
import { CommonListQuery } from '../../../redux/api/apiTypes';
import { ProcedureList, ProcedureResponse, ProcedureSearch } from '../types';


export const procedureApi = systemApi.injectEndpoints({
    endpoints: (builder) => ({
        getProcedureList: builder.query<ProcedureList, ProcedureSearch & CommonListQuery>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `manager-procedure/search?page=${page || 0}&size=${size || 10}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest,
                })
            },
            transformResponse: (response: { body: ProcedureList }, meta, arg) => {
                return response.body;
            }
        }),
        getProcedureById: builder.query<ProcedureResponse, number>({
            query: (id) => `manager-procedure/${id}`,
            transformResponse: (response: { body: ProcedureResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useLazyGetProcedureListQuery,
    useLazyGetProcedureByIdQuery } = procedureApi;
